import React from 'react';
import { Col, OverlayTrigger, Row, Tooltip, Button } from 'react-bootstrap-5';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faInfoCircle, faLock } from '@fortawesome/pro-regular-svg-icons';
import { profilePremiumSignupUrl } from 'bundles/connect/helpers/prospect_api';
import { faSparkles } from '@fortawesome/pro-solid-svg-icons';

type Props = {
  hasActiveProduct: boolean;
  label: string;
  value: string | number | boolean | null | undefined;
  restricted?: boolean;
};

const LABEL_TOOLTIP_MAP: Record<string, string> = {
  'Assessed Market Value':
    'The market value of the property as reported by the county or city tax \
    assessment authority. </br></br> <strong>Note</strong>:\
    This differs from the Buildout Estimate which is based on a comparison with similar \
    properties in the market, factoring in attributes like sale price, building class, and investment type.',
  'Assessed Tax Value':
    'The assessed value of the property as reported by the county or city tax \
    assessment authority. </br></br> <strong>Note</strong>:\
    This differs from the Buildout Estimate which is based on a comparison with similar \
    properties in the market, factoring in attributes like sale price, building class, and investment type.'
};

export default function PropertyInfoRow({
  label,
  value,
  restricted = false,
  hasActiveProduct = false
}: Props) {
  const tooltipHtml = LABEL_TOOLTIP_MAP[label];

  const renderTooltip = (props: any) => (
    <Tooltip {...props}>
      <div dangerouslySetInnerHTML={{ __html: tooltipHtml ?? '' }} />
    </Tooltip>
  );

  const renderValue = () => {
    if (restricted) {
      if (hasActiveProduct) {
        return (
          <span className="badge rounded-pill text-bg-light fw-normal">
            <FontAwesomeIcon className="me-1" icon={faLock} />
            Locked
          </span>
        );
      } else {
        return (
          <Button
            href={profilePremiumSignupUrl}
            rel="noopener noreferrer"
            size="sm"
            target="_blank"
            variant="shaded-secondary"
          >
            <FontAwesomeIcon className="me-1" icon={faSparkles} />
            Upgrade To Access
          </Button>
        );
      }
    }

    return value;
  };

  return (
    <Row className="gx-0 border-bottom border-light align-items-center py-2">
      <Col lg={5} xs>
        <span className="fw-bold">
          {label}
          {tooltipHtml && (
            <OverlayTrigger overlay={renderTooltip} placement="top">
              <FontAwesomeIcon
                className="ms-2 text-primary"
                icon={faInfoCircle}
                style={{ cursor: 'pointer' }}
              />
            </OverlayTrigger>
          )}
        </span>
      </Col>
      <Col>{renderValue()}</Col>
    </Row>
  );
}
